import { render, staticRenderFns } from "./Route.vue?vue&type=template&id=008343c6&scoped=true&"
import script from "./Route.vue?vue&type=script&lang=ts&"
export * from "./Route.vue?vue&type=script&lang=ts&"
import style0 from "./Route.vue?vue&type=style&index=0&id=008343c6&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008343c6",
  null
  
)

export default component.exports